<template>
  <div id="asset-filter-box" @show="reset">
    <toggle-box
      :text="$t('FILTERS')"
      white
      pure-icon
      ref="box"
      @close="cancel"
    >
      <template v-slot:icon>
        <font-awesome-icon class="icon" :icon="faFilter" />
      </template>

      <template v-slot:content>
        <div class="filters-assets">
          <bamboo-input
            :items="branchesList"
            :label="$t('BRANCH')"
            v-model="branch"
            required
            multiple
            ref="branchesInput"
          />
        </div>
        <div class="btns">
          <primary-button :text="$t('CLEAR')" rounded-corner independence @click="clear" />
          <primary-button :text="$t('FILTER')" rounded-corner independence @click="apply" />
        </div>
      </template>
    </toggle-box>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import ToggleBox from '@/components/ToggleBox';
import BambooInput from '@/components/BambooInput';
import PrimaryButton from '@/components/PrimaryButton';

const { useState: useAppState } = createNamespacedHelpers('app');
const { useState, useActions } = createNamespacedHelpers('assetsList');

export default {
  components: {
    FontAwesomeIcon,
    ToggleBox,
    BambooInput,
    PrimaryButton,
  },
  setup() {
    const { branches } = useAppState(['branches']);
    const { filters } = useState(['items', 'filters', 'total']);
    const { applyFilter } = useActions(['applyFilter']);


    const branchesList = computed(() => branches.value.filter((b) => !['HO', 'LVL', 'GD'].includes(b.name)).map((b) => ({
      value: b.id,
      text: b.name
    })));

    const box = ref(null);

    const branch = ref(filters.branch || branchesList.value.map((item) => item.value));
    const branchesInput = ref(null);

    const cancel = () => {
      box.value.toggle(false);
    };

    const reset = () => {
      branch.value = filters.branch || branchesList.value.map((item) => item.value);
    };

    const apply = () => {
      const inputs = [
        branchesInput.value
      ];

      let valid = true;

      inputs.forEach((input) => {
        const inputValidity = input.validateInput();
        valid = valid && inputValidity;
      });

      if (valid) {
        applyFilter({
          branch: branch.value,
          fromDate: null,
          toDate: null
        });

        box.value.toggle(false);
      }
    };

    const clear = (e) => {
      e.stopPropagation();

      branch.value = branchesList.value.map((item) => item.value);
    };

    return {
      box,
      faFilter,
      branchesList,
      cancel,
      apply,
      branchesInput,
      branches,
      filters,
      clear,
      reset,
      branch,
    };
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';

#asset-filter-box {
  margin-right: 5px;
  .filters-assets {
    width: 300px;
    justify-content: center;

    .amounts {
      display: flex;
      align-items: top;
      justify-content: space-between;

        .text-input {
          width: calc(50% - 5px);

          input {
            width: 100%;
            border-radius: 4px;
          }
        }
    }

    .input {
      margin-bottom: 20px;
    }
  }
  .btns {
    text-align: right;
    margin-top: 15px;
    margin-bottom: 5px;

    .primary-button {
      margin-left: 10px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>
